<app-menu></app-menu>

<section class="controldocs-page" *ngIf="tenantId; else docsEmptyState">
  <aside class="docs-sidebar">
    <div class="sidebar-brand">
      <p>Visão pessoal</p>
      <h2>ControlDocs</h2>
    </div>

    <nav class="sidebar-nav">
      <button type="button" class="sidebar-item" [class.active]="activeSection === 'dashboard'" (click)="switchSection('dashboard')">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
      </button>
      <button type="button" class="sidebar-item" [class.active]="activeSection === 'workspace'" (click)="switchSection('workspace')">
        <mat-icon>star</mat-icon>
        <span>My Workspace</span>
      </button>
      <button type="button" class="sidebar-item" [class.active]="activeSection === 'shared'" (click)="switchSection('shared')">
        <mat-icon>share</mat-icon>
        <span>Compartilhados</span>
      </button>
      <button type="button" class="sidebar-item" [class.active]="activeSection === 'trash'" (click)="switchSection('trash')">
        <mat-icon>delete_outline</mat-icon>
        <span>Lixeira</span>
      </button>
    </nav>

    <div class="sidebar-folders">
      <div class="section-head">
        <p>Favoritos</p>
      </div>

      <div class="folder-list" *ngIf="favoriteFolders.length; else noFavorites">
        <button
          type="button"
          class="nav-item group"
          *ngFor="let folder of favoriteFolders; trackBy: trackById"
          [class.active]="currentFolder?.id === folder.id"
          (click)="openFolderFromListing(folder)">
          <div class="item-info">
            <mat-icon>folder</mat-icon>
            <div>
              <strong class="root-folder-name" [title]="folder.name">{{ folder.name }}</strong>
              <small class="badge" [class.public]="folder.visibility === 'PUBLIC'" [class.private]="folder.visibility !== 'PUBLIC'">
                {{ folder.visibility === 'PUBLIC' ? 'Pública' : 'Particular' }}
              </small>
            </div>
          </div>
          <div class="folder-actions">
            <div class="action-menu">
              <button class="icon-button action-trigger" type="button" (click)="toggleActionMenu('sidebar-folder-' + folder.id, $event)">
                <mat-icon>more_vert</mat-icon>
              </button>
              <div class="action-dropdown" *ngIf="isActionMenuOpen('sidebar-folder-' + folder.id)" (click)="$event.stopPropagation()">
                <button type="button" (click)="onFolderAction('details', folder, $event)">
                  <mat-icon>info</mat-icon>
                  <span>Detalhes</span>
                </button>
                <button type="button" (click)="onFolderAction('share', folder, $event)">
                  <mat-icon>share</mat-icon>
                  <span>Compartilhar</span>
                </button>
                <button type="button" (click)="onFolderAction('favorite', folder, $event)">
                  <mat-icon>{{ isFavorite(folder) ? 'star' : 'star_border' }}</mat-icon>
                  <span>{{ isFavorite(folder) ? 'Desfavoritar' : 'Favoritar' }}</span>
                </button>
                <button type="button" class="danger" (click)="onFolderAction('delete', folder, $event)">
                  <mat-icon>delete</mat-icon>
                  <span>Excluir</span>
                </button>
              </div>
            </div>
          </div>
        </button>
      </div>
      <ng-template #noFavorites>
        <div class="sidebar-empty">Nenhuma pasta favorita.</div>
      </ng-template>
    </div>
  </aside>

  <main class="docs-main">
    <header class="docs-topbar">
      <div class="topbar-row">
        <div class="breadcrumb">
          <button type="button" (click)="goToRoot()">Raiz</button>
          <ng-container *ngIf="hasBreadcrumbEllipsis">
            <span>/</span>
            <span class="crumb-ellipsis">(...)</span>
          </ng-container>
          <ng-container *ngFor="let folder of visibleBreadcrumb">
            <span>/</span>
            <button type="button" (click)="navigateToById(folder.id)">{{ folder.name }}</button>
          </ng-container>
        </div>
        <div class="actions">
          <label class="upload-btn primary-action">
            <input type="file" multiple (change)="handleUpload($event)" [disabled]="uploading || !currentFolder">
            <mat-icon>upload</mat-icon>
            <span>{{ uploading ? 'Enviando...' : 'Enviar arquivos' }}</span>
          </label>
          <button class="btn outline" type="button" (click)="toggleNewFolderForm()">Nova pasta</button>
        </div>
      </div>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field docs-search-field">
        <mat-label>Pesquisar arquivos</mat-label>
        <mat-icon matIconPrefix>search</mat-icon>
        <input matInput type="search" placeholder="Pesquisar arquivos..." [(ngModel)]="searchTerm">
      </mat-form-field>
    </header>

    <ng-container *ngIf="activeSection === 'dashboard'; else foldersSection">
    <section class="panel">
      <header class="panel-head">
        <h3>Pastas recentes</h3>
      </header>
      <div class="recent-folders-grid" *ngIf="recentFolders.length; else noSubfolders">
        <article class="recent-folder-card" *ngFor="let folder of recentFolders; trackBy: trackById" (click)="openFolderFromDashboard(folder)">
          <div class="folder-card-top">
            <div class="folder-content">
              <mat-icon>folder</mat-icon>
              <div>
                <strong>{{ folder.name }}</strong>
                <small class="badge" [class.public]="folder.visibility === 'PUBLIC'" [class.private]="folder.visibility !== 'PUBLIC'">
                  <span class="status-dot"></span>
                  {{ folder.visibility === 'PUBLIC' ? 'Pública' : 'Particular' }}
                </small>
              </div>
            </div>
            <div class="action-menu">
              <button class="icon-button action-trigger" type="button" (click)="toggleActionMenu('recent-folder-' + folder.id, $event)">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <div class="action-dropdown" *ngIf="isActionMenuOpen('recent-folder-' + folder.id)" (click)="$event.stopPropagation()">
                <button type="button" (click)="onFolderAction('details', folder, $event)">
                  <mat-icon>info</mat-icon>
                  <span>Detalhes</span>
                </button>
                <button type="button" (click)="onFolderAction('share', folder, $event)">
                  <mat-icon>share</mat-icon>
                  <span>Compartilhar</span>
                </button>
                <button type="button" (click)="onFolderAction('favorite', folder, $event)">
                  <mat-icon>{{ isFavorite(folder) ? 'star' : 'star_border' }}</mat-icon>
                  <span>{{ isFavorite(folder) ? 'Desfavoritar' : 'Favoritar' }}</span>
                </button>
                <button type="button" class="danger" (click)="onFolderAction('delete', folder, $event)">
                  <mat-icon>delete</mat-icon>
                  <span>Excluir</span>
                </button>
              </div>
            </div>
          </div>
          <div class="folder-card-stats">
            <div class="folder-count">
              <strong>{{ folder.item_count || 0 }}</strong>
              <span>arquivos</span>
            </div>
            <button class="mini-folder-btn" type="button" (click)="$event.stopPropagation()">
              <mat-icon>folder_open</mat-icon>
            </button>
          </div>
          <div class="folder-card-divider"></div>
          <div class="folder-card-updated">
            Atualizado {{ folder.created_at | date: 'short' }}
          </div>
        </article>
      </div>
    </section>

    <section class="content-grid">
      <div class="panel">
        <header class="panel-head">
          <h3>Arquivos recentes</h3>
          <small>{{ recentFiles.length }} de 10</small>
        </header>
        <div class="recent-files-list" [class.scrollable]="recentFilesScrollable" *ngIf="recentFiles.length; else noFiles">
          <article class="file-row" *ngFor="let file of recentFiles; trackBy: trackById" (click)="openFile(file, $event)">
            <div class="file-main">
              <div class="file-icon">
                <mat-icon>{{ fileTypeIcon(file) }}</mat-icon>
              </div>
              <div class="file-info">
                <strong>{{ fileDisplayName(file) }}</strong>
                <small>{{ file.file_type }} · {{ file.file_size | number }} bytes</small>
              </div>
            </div>
            <div class="file-row-right">
              <small>{{ file.uploaded_at | date: 'short' }}</small>
              <div class="action-menu">
                <button class="icon-button action-trigger" type="button" (click)="toggleActionMenu('recent-file-' + file.id, $event)">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <div class="action-dropdown" *ngIf="isActionMenuOpen('recent-file-' + file.id)" (click)="$event.stopPropagation()">
                  <button type="button" (click)="onFileAction('details', file, $event)">
                    <mat-icon>info</mat-icon>
                    <span>Detalhes</span>
                  </button>
                  <button type="button" (click)="onFileAction('share', file, $event)">
                    <mat-icon>share</mat-icon>
                    <span>Compartilhar</span>
                  </button>
                  <button type="button" class="danger" (click)="onFileAction('delete', file, $event)">
                    <mat-icon>delete</mat-icon>
                    <span>Excluir</span>
                  </button>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>

      <div class="panel">
        <header class="panel-head">
          <h3>Atividade recente</h3>
          <small>{{ recentActivities.length }} de 20</small>
        </header>
        <div class="activity-list" [class.scrollable]="activityListScrollable" *ngIf="recentActivities.length; else noActivity">
          <article class="activity-item" *ngFor="let item of recentActivities; trackBy: trackById">
            <div class="avatar-dot">MP</div>
            <div class="activity-info">
              <strong>{{ activityLabel(item) }}: {{ activityTargetName(item) }}</strong>
              <small>{{ item.created_at | date: 'short' }}</small>
            </div>
            <mat-icon>check_circle</mat-icon>
          </article>
        </div>
      </div>
    </section>
    </ng-container>

    <ng-template #foldersSection>
      <section class="panel">
        <header class="panel-head">
          <h3>{{ activeSection === 'workspace' ? 'My Workspace' : activeSection === 'shared' ? 'Compartilhados' : activeSection === 'trash' ? 'Lixeira' : 'Documentos' }}</h3>
          <div class="panel-head-actions">
            <small>{{ documentCount }} itens</small>
          </div>
        </header>
        <div
          class="compact-dropzone"
          *ngIf="activeSection === 'documents' && currentFolder"
          [class.drag-over]="dropzoneDragOver"
          (dragover)="onDropzoneDragOver($event)"
          (dragleave)="onDropzoneDragLeave($event)"
          (drop)="onDropzoneDrop($event)"
          (click)="persistentDropzoneInput.click()">
          <input
            #persistentDropzoneInput
            type="file"
            multiple
            hidden
            (click)="$event.stopPropagation()"
            (change)="handleUpload($event)"
            [disabled]="uploading">
          <mat-icon>{{ uploading ? 'hourglass_top' : 'upload_file' }}</mat-icon>
          <div class="compact-dropzone__content">
            <strong>{{ uploading ? 'Enviando arquivos...' : 'Arraste arquivos aqui ou clique para enviar' }}</strong>
            <small>O dropzone fica disponível o tempo todo nesta pasta, além do botão “Enviar arquivos”.</small>
          </div>
        </div>
        <div class="upload-error" *ngIf="uploadError">
          <mat-icon>error_outline</mat-icon>
          <span>{{ uploadError }}</span>
        </div>
        <div class="documents-table-wrap" [class.scrollable]="documentRows.length >= 6" *ngIf="documentRows.length; else noSubfolders">
          <table class="folders-table">
            <colgroup>
              <col class="col-doc" [style.width]="columnWidthStyle('name')">
              <col class="col-type" [style.width]="columnWidthStyle('type')">
              <col class="col-items" [style.width]="columnWidthStyle('items')">
              <col class="col-updated" [style.width]="columnWidthStyle('updated')">
              <col class="col-owner" [style.width]="columnWidthStyle('owner')">
              <col class="col-updated" *ngIf="activeSection === 'trash'" [style.width]="columnWidthStyle('trashMeta')">
              <col class="col-visibility" *ngIf="activeSection !== 'trash'" [style.width]="columnWidthStyle('visibility')">
              <col class="col-sharing" *ngIf="activeSection !== 'trash'" [style.width]="columnWidthStyle('sharing')">
              <col class="col-actions" [style.width]="columnWidthStyle('actions')">
            </colgroup>
            <thead>
              <tr>
                <th class="sortable-head" (click)="onSortHeaderClick('name', $event)">
                  <span class="head-label">
                    <span>Nome</span>
                    <mat-icon class="sort-icon" [class.active]="documentSort.field === 'name'">{{ sortIndicator('name') }}</mat-icon>
                  </span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('name', $event)"></span>
                </th>
                <th class="sortable-head" (click)="onSortHeaderClick('type', $event)">
                  <span class="head-label">
                    <span>Tipo</span>
                    <mat-icon class="sort-icon" [class.active]="documentSort.field === 'type'">{{ sortIndicator('type') }}</mat-icon>
                  </span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('type', $event)"></span>
                </th>
                <th>
                  <span class="head-label">Itens</span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('items', $event)"></span>
                </th>
                <th class="sortable-head" (click)="onSortHeaderClick('updated_at', $event)">
                  <span class="head-label">
                    <span>{{ activeSection === 'trash' ? 'Data da exclusão' : 'Atualização' }}</span>
                    <mat-icon class="sort-icon" [class.active]="documentSort.field === 'updated_at'">{{ sortIndicator('updated_at') }}</mat-icon>
                  </span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('updated', $event)"></span>
                </th>
                <th>
                  <span class="head-label">Proprietário</span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('owner', $event)"></span>
                </th>
                <th *ngIf="activeSection === 'trash'">
                  <span class="head-label">Prazo restante</span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('trashMeta', $event)"></span>
                </th>
                <th *ngIf="activeSection !== 'trash'">
                  <span class="head-label">Visibilidade</span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('visibility', $event)"></span>
                </th>
                <th *ngIf="activeSection !== 'trash'">
                  <span class="head-label">Compartilhamento</span>
                  <span class="column-resize-handle" (mousedown)="startColumnResize('sharing', $event)"></span>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of documentRows; trackBy: trackByDocumentRow"
                (click)="onDocumentRowClick(row, $event)"
                [class.folder-drop-target]="isFolderDropTarget(row)"
                [attr.draggable]="isDocumentRowDraggable(row) ? true : null"
                (dragstart)="onDocumentRowDragStart(row, $event)"
                (dragend)="onDocumentRowDragEnd()"
                (dragover)="onFolderRowDragOver(row, $event)"
                (dragleave)="onFolderRowDragLeave(row, $event)"
                (drop)="onFolderRowDrop(row, $event)">
                <td class="folder-name-cell">
                  <span class="list-cell-with-icon">
                    <mat-icon [class.folder-type-icon]="row.kind === 'folder'">{{ documentRowIcon(row) }}</mat-icon>
                    <span class="list-cell-main">
                      <ng-container *ngIf="!isInlineRenaming(row); else inlineRenameField">
                        <span class="list-cell-title">{{ documentRowName(row) }}</span>
                      </ng-container>
                      <ng-template #inlineRenameField>
                        <span class="inline-rename-field" (click)="$event.stopPropagation()">
                          <input
                            type="text"
                            [(ngModel)]="inlineRenameValue"
                            [disabled]="inlineRenameSaving"
                            (keydown.enter)="saveInlineRename(row, $event)"
                            (keydown.escape)="cancelInlineRename($event)"
                            autofocus />
                          <button class="row-quick-btn" type="button" (click)="saveInlineRename(row, $event)" title="Salvar">
                            <mat-icon>check</mat-icon>
                          </button>
                          <button class="row-quick-btn" type="button" (click)="cancelInlineRename($event)" title="Cancelar">
                            <mat-icon>close</mat-icon>
                          </button>
                        </span>
                      </ng-template>
                      <span
                        class="row-quick-actions"
                        *ngIf="canShowRowQuickActions(row)"
                        [class.menu-open]="isActionMenuOpen(documentRowMenuKey('documents-list', row))">
                        <button class="row-quick-btn" type="button" (click)="onDocumentRowDetails(row, $event)" title="Detalhes">
                          <mat-icon>info</mat-icon>
                        </button>
                        <button class="row-quick-btn" *ngIf="row.kind === 'folder' && canManageSharedActions()" type="button" (click)="onDocumentRowShare(row, $event)" title="Compartilhar">
                          <mat-icon>share</mat-icon>
                        </button>
                        <button class="row-quick-btn" *ngIf="row.kind === 'folder'" type="button" (click)="onDocumentRowFavorite(row, $event)" [title]="isDocumentRowFavorite(row) ? 'Desfavoritar' : 'Favoritar'">
                          <mat-icon>{{ isDocumentRowFavorite(row) ? 'star' : 'star_border' }}</mat-icon>
                        </button>
                        <button class="row-quick-btn" *ngIf="row.kind === 'file'" type="button" (click)="onDocumentRowQuickOpen(row, $event)" title="Abrir">
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                        <button class="row-quick-btn" *ngIf="row.kind === 'file'" type="button" (click)="onDocumentRowQuickDownload(row, $event)" title="Baixar">
                          <mat-icon>download</mat-icon>
                        </button>
                        <span class="action-menu row-quick-menu" [class.open]="isActionMenuOpen(documentRowMenuKey('documents-list', row))">
                          <button
                            class="row-quick-btn"
                            type="button"
                            (click)="toggleActionMenu(documentRowMenuKey('documents-list', row), $event, row)"
                            title="Mais ações">
                            <mat-icon>more_horiz</mat-icon>
                          </button>
                        </span>
                      </span>
                    </span>
                  </span>
                </td>
                <td>{{ documentRowType(row) }}</td>
                <td>{{ documentRowItemCount(row) }}</td>
                <td class="updated-cell" [title]="(documentRowUpdatedAt(row) | date: 'short')">
                  <span class="cell-ellipsis">{{ documentRowUpdatedAt(row) | date: 'short' }}</span>
                </td>
                <td class="owner-cell" [title]="documentRowOwner(row)">
                  <span class="cell-ellipsis">{{ documentRowOwner(row) }}</span>
                </td>
                <td *ngIf="activeSection === 'trash'">
                  <span class="cell-ellipsis">{{ documentRowDaysRemaining(row) }}</span>
                </td>
                <td *ngIf="activeSection !== 'trash'">
                  <small class="badge" [class.public]="documentRowVisibility(row) === 'PUBLIC'" [class.private]="documentRowVisibility(row) !== 'PUBLIC'">
                    {{ documentRowVisibility(row) === 'PUBLIC' ? 'Pública' : 'Particular' }}
                  </small>
                </td>
                <td *ngIf="activeSection !== 'trash'">
                  <button class="share-link-btn" *ngIf="documentRowHasShareLink(row); else noShareActive" type="button" (click)="onDocumentRowShare(row, $event)">
                    <mat-icon>link</mat-icon>
                    <span>Gerenciar</span>
                  </button>
                  <ng-template #noShareActive>
                    <span class="no-share-label">-</span>
                  </ng-template>
                </td>
                <td class="folder-card-actions action-cell">
                  <span class="no-share-label" *ngIf="activeSection === 'trash' && currentFolder">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </ng-template>
  </main>
</section>

<ng-template #noSubfolders>
  <div
    class="empty-state dropzone-state"
    [class.drag-over]="dropzoneDragOver"
    *ngIf="activeSection === 'documents' && currentFolder; else genericNoSubfolders"
    (dragover)="onDropzoneDragOver($event)"
    (dragleave)="onDropzoneDragLeave($event)"
    (drop)="onDropzoneDrop($event)"
    (click)="dropzoneInput.click()">
    <input
      #dropzoneInput
      type="file"
      multiple
      (click)="$event.stopPropagation()"
      (change)="handleUpload($event)"
      [disabled]="uploading"
      hidden>
    <mat-icon>{{ uploading ? 'hourglass_top' : 'upload_file' }}</mat-icon>
    <p>{{ uploading ? 'Enviando arquivos...' : 'Nenhuma pasta ou arquivos encontrados.' }}</p>
    <small>Clique ou arraste arquivos aqui para enviar para esta pasta.</small>
  </div>
  <ng-template #genericNoSubfolders>
  <div class="empty-state">
    <mat-icon>create_new_folder</mat-icon>
    <p>Nenhuma pasta ou arquivo encontrado.</p>
    <small>{{ activeSection === 'shared' ? 'Os itens compartilhados com você aparecerão aqui.' : activeSection === 'trash' ? 'Itens enviados para a lixeira aparecerão aqui.' : 'Crie uma pasta ou envie um arquivo para organizar seus documentos.' }}</small>
  </div>
  </ng-template>
</ng-template>

<ng-template #noFiles>
  <div class="empty-state">
    <mat-icon>description</mat-icon>
    <p>Nenhum arquivo carregado nesta pasta.</p>
    <small>Use “Enviar arquivos” para começar.</small>
  </div>
</ng-template>

<ng-template #noActivity>
  <div class="empty-state">
    <mat-icon>history</mat-icon>
    <p>Sem atividades recentes.</p>
    <small>As ações de arquivos aparecerão aqui.</small>
  </div>
</ng-template>

<ng-template #docsEmptyState>
  <section class="empty-state-full">
    <p>Faça login para acessar o ControlDocs.</p>
  </section>
</ng-template>

<div class="share-modal-backdrop" *ngIf="showNewFolderForm" (click)="toggleNewFolderForm()"></div>
<section class="modal-card cp-standard-modal docs-create-folder-modal" *ngIf="showNewFolderForm" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div class="modal-title-wrap">
      <h2>Nova pasta</h2>
      <p class="modal-subtitle">Defina o nome e a visibilidade da pasta.</p>
    </div>
    <button class="icon-button" type="button" (click)="toggleNewFolderForm()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="cp-modal__body">
    <form [formGroup]="folderForm" (ngSubmit)="createFolder()" class="create-folder-form">
      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Nome da pasta</mat-label>
        <input matInput type="text" formControlName="name" placeholder="Digite o nome da pasta">
      </mat-form-field>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Visibilidade</mat-label>
        <mat-select formControlName="visibility">
          <mat-option value="PRIVATE">Particular</mat-option>
          <mat-option value="PUBLIC">Pública</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <footer class="cp-modal__footer">
    <button class="btn outline" type="button" (click)="toggleNewFolderForm()">Cancelar</button>
    <button class="btn primary" type="button" (click)="createFolder()">Criar pasta</button>
  </footer>
</section>

<div class="share-modal-backdrop" *ngIf="confirmModalVisible" (click)="closeConfirmModal()"></div>
<section class="modal-card cp-standard-modal docs-delete-modal" *ngIf="confirmModalVisible" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ confirmModalHeading }}</h2>
      <p class="modal-subtitle">{{ confirmModalTitle }}</p>
    </div>
    <button class="icon-button" type="button" (click)="closeConfirmModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="cp-modal__body">
    <p class="delete-modal-copy">{{ confirmModalDescription }}</p>
  </div>
  <footer class="cp-modal__footer">
    <button class="btn outline" type="button" (click)="closeConfirmModal()" [disabled]="confirmSubmitting">Cancelar</button>
    <button class="btn" [class.danger]="confirmAction === 'permanent_delete'" [class.primary]="confirmAction !== 'permanent_delete'" type="button" (click)="confirmActionSubmit()" [disabled]="confirmSubmitting">
      {{ confirmModalButtonLabel }}
    </button>
  </footer>
</section>

<div
  class="action-dropdown action-dropdown-fixed global-row-action-menu"
  *ngIf="actionMenuRow && actionMenuKey"
  [ngStyle]="actionMenuStyle(actionMenuKey)"
  (click)="$event.stopPropagation()">
  <button type="button" *ngIf="activeSection !== 'trash'" (click)="onDocumentRowDetails(actionMenuRow, $event)">
    <mat-icon>info</mat-icon>
    <span>Detalhes</span>
  </button>
  <button type="button" *ngIf="activeSection !== 'trash' && canManageSharedActions()" (click)="onDocumentRowShare(actionMenuRow, $event)">
    <mat-icon>share</mat-icon>
    <span>Compartilhar</span>
  </button>
  <button type="button" *ngIf="activeSection !== 'trash' && actionMenuRow.kind === 'folder'" (click)="onDocumentRowFavorite(actionMenuRow, $event)">
    <mat-icon>{{ isDocumentRowFavorite(actionMenuRow) ? 'star' : 'star_border' }}</mat-icon>
    <span>{{ isDocumentRowFavorite(actionMenuRow) ? 'Desfavoritar' : 'Favoritar' }}</span>
  </button>
  <button type="button" *ngIf="activeSection !== 'trash'" (click)="startInlineRename(actionMenuRow, $event)">
    <mat-icon>drive_file_rename_outline</mat-icon>
    <span>Renomear</span>
  </button>
  <button type="button" *ngIf="activeSection === 'trash'" (click)="actionMenuRow.kind === 'folder' ? restoreFolder(actionMenuRow.folder, $event) : restoreFile(actionMenuRow.file, $event)">
    <mat-icon>restore</mat-icon>
    <span>Restaurar</span>
  </button>
  <button type="button" class="danger" *ngIf="activeSection === 'trash'" (click)="actionMenuRow.kind === 'folder' ? permanentlyDeleteFolder(actionMenuRow.folder, $event) : permanentlyDeleteFile(actionMenuRow.file, $event)">
    <mat-icon>delete_forever</mat-icon>
    <span>Excluir permanentemente</span>
  </button>
  <button type="button" class="danger" *ngIf="activeSection !== 'trash' && canManageSharedActions()" (click)="onDocumentRowDelete(actionMenuRow, $event)">
    <mat-icon>delete</mat-icon>
    <span>Excluir</span>
  </button>
</div>

<div class="modal-backdrop" *ngIf="detailsModalVisible" (click)="closeDetailsModal()"></div>
<section class="modal-card cp-modal-fixed-height docs-details-modal" *ngIf="detailsModalVisible" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Detalhes: {{ detailsTarget?.name }}</h2>
    </div>
    <button class="icon-button" type="button" (click)="closeDetailsModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="cp-tabs docs-details-tabs">
    <button type="button" [class.active]="detailsTab === 'details'" (click)="detailsTab = 'details'">Detalhes</button>
    <button type="button" *ngIf="canManageSharedActions()" [class.active]="detailsTab === 'sharing'" (click)="detailsTab = 'sharing'">Compartilhamento</button>
    <button type="button" *ngIf="canManageSharedActions()" [class.active]="detailsTab === 'external'" (click)="detailsTab = 'external'">Link externo</button>
  </div>

  <div class="cp-modal__body docs-details-body">
    <div class="details-tab-content" *ngIf="detailsTab === 'details'">
      <div class="current-share-grid">
        <div class="full-row">
          <span class="current-label">Documento</span>
          <p>{{ detailsTarget?.name }}</p>
        </div>
        <div>
          <span class="current-label">Data da criação</span>
          <p>{{ detailsTarget?.createdAt | date:'short' }}</p>
        </div>
        <div>
          <span class="current-label">Criado por</span>
          <p>{{ detailsTarget?.createdBy || '-' }}</p>
        </div>
      </div>

      <div class="docs-details-form-row" *ngIf="canRenameDetailsTarget">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>{{ detailsTarget?.type === 'FOLDER' ? 'Nome da pasta' : 'Nome do arquivo' }}</mat-label>
          <input matInput [(ngModel)]="detailsName" placeholder="Digite o novo nome">
        </mat-form-field>
        <button class="btn primary" type="button" (click)="saveDetailsName()" [disabled]="detailsNameSaving">
          {{ detailsNameSaving ? 'Salvando...' : 'Renomear' }}
        </button>
      </div>

      <div class="docs-details-form-row" *ngIf="canManageSharedActions()">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Visibilidade</mat-label>
          <mat-select [(ngModel)]="detailsVisibility" [disabled]="detailsVisibilitySaving">
            <mat-option value="PRIVATE">Particular</mat-option>
            <mat-option value="PUBLIC">Pública</mat-option>
          </mat-select>
        </mat-form-field>
        <button class="btn primary" type="button" (click)="saveDetailsVisibility()" [disabled]="detailsVisibilitySaving">
          {{ detailsVisibilitySaving ? 'Salvando...' : 'Salvar visibilidade' }}
        </button>
      </div>
    </div>

    <div class="details-tab-content" *ngIf="canManageSharedActions() && detailsTab === 'sharing'">
      <div class="current-share-grid">
        <div class="full-row">
          <span class="current-label">Visibilidade</span>
          <p>{{ detailsVisibility === 'PUBLIC' ? 'Pública' : 'Particular' }}</p>
        </div>
      </div>

      <div class="inline-field" *ngIf="detailsVisibility === 'PUBLIC'">
        <label>Usuários com acesso</label>
        <div class="users-tag-field" (click)="$event.stopPropagation()">
          <div class="users-tag-input-wrap" (click)="onAccessSearchFocus($event)">
            <span class="user-tag" *ngFor="let tag of accessGrantTags">
              <span>{{ tag.label }}</span>
              <button type="button" (click)="removeAccessGrantTag(tag.email, $event)">
                <mat-icon>close</mat-icon>
              </button>
            </span>
            <input
              type="text"
              [(ngModel)]="accessSearchTerm"
              [disabled]="accessGrantsLoading || accessGrantsSaving"
              placeholder="Buscar usuário por nome ou e-mail"
              (focus)="onAccessSearchFocus($event)"
              (input)="onAccessSearchInput($event)"
              (keydown.enter)="onAccessSearchConfirm($event)" />
          </div>
          <div class="users-search-dropdown" *ngIf="showAccessSearchResults" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="user-search-row"
              *ngFor="let user of filteredTenantUsers"
              (click)="addAccessGrantUser(user)">
              <span class="user-search-name">{{ user.name || user.email }}</span>
              <small>{{ user.email }}</small>
            </button>
            <div class="user-search-empty" *ngIf="!filteredTenantUsers.length">
              Nenhum usuário encontrado. Pressione Enter para adicionar como e-mail.
            </div>
          </div>
        </div>
        <div class="modal-footer-actions">
          <button class="btn primary" type="button" (click)="saveAccessGrants()" [disabled]="accessGrantsSaving">
            {{ accessGrantsSaving ? 'Salvando...' : 'Salvar permissões' }}
          </button>
        </div>
      </div>

      <div class="inline-field" *ngIf="detailsVisibility !== 'PUBLIC'">
        <small>Documento particular: acesso interno restrito ao proprietário.</small>
      </div>
    </div>

    <div class="details-tab-content" *ngIf="canManageSharedActions() && detailsTab === 'external'">
      <form [formGroup]="shareForm" (ngSubmit)="generateShareLink()" class="docs-external-form">
        <div class="docs-toggle-grid">
          <label class="toggle-row modern-checkbox">
            <input type="checkbox" [(ngModel)]="shareIsActive" [ngModelOptions]="{ standalone: true }" />
            <span>Link ativo (desmarque para tirar do ar)</span>
          </label>

          <label class="toggle-row modern-checkbox">
            <input type="checkbox" formControlName="password_enabled" [disabled]="!shareIsActive" />
            <span>Proteger com senha</span>
          </label>
        </div>

        <div class="docs-external-fields">
          <label>Senha
            <div class="password-row modal-input-row">
              <input type="text" formControlName="password" placeholder="Defina uma senha segura" [disabled]="!shareIsActive || !shareForm.value.password_enabled" />
              <button class="btn ghost" type="button" (click)="generateStrongPassword()" [disabled]="!shareIsActive">Gerar senha forte</button>
            </div>
          </label>

          <label>Expira em
            <input type="date" formControlName="expires_at" [disabled]="!shareIsActive" />
          </label>
        </div>

        <div class="existing-link-box" *ngIf="shareLinkId">
          <small>Dados atuais</small>
          <div class="current-share-grid">
            <div class="full-row">
              <span class="current-label">Link atual</span>
              <div class="current-value-row">
                <p class="is-link">{{ shareLink || '-' }}</p>
                <button class="btn ghost mini" type="button" (click)="copyShareLink()" [disabled]="!shareLink">Copiar</button>
              </div>
            </div>
            <div class="full-row">
              <span class="current-label">Senha atual</span>
              <div class="current-value-row">
                <p>{{ shareCurrentPasswordValue || '-' }}</p>
                <button class="btn ghost mini" type="button" (click)="copyCurrentSharePassword()">Copiar</button>
              </div>
            </div>
            <div>
              <span class="current-label">Expiração atual</span>
              <p>{{ shareCurrentExpiresAt ? (shareCurrentExpiresAt | date:'short') : 'Sem expiração' }}</p>
            </div>
            <div>
              <span class="current-label">Status</span>
              <p>{{ shareIsActive ? 'Ativo' : 'Inativo' }}</p>
            </div>
          </div>
        </div>

        <div class="modal-footer-actions">
          <button class="btn primary" type="submit" [disabled]="!canSubmitShare()">
            {{ shareGenerating ? 'Salvando...' : (shareLinkId ? 'Salvar compartilhamento' : 'Gerar link') }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <footer class="cp-modal__footer">
    <button class="btn outline" type="button" (click)="closeDetailsModal()">Fechar</button>
  </footer>
</section>

<div class="share-modal-backdrop" *ngIf="shareModalVisible">
  <div class="share-modal cp-standard-modal">
    <header>
      <div class="modal-title-wrap">
        <h3>Compartilhar {{ shareTarget?.name }}</h3>
        <small>Gere um link seguro para {{ shareTarget?.type === 'FILE' ? 'o arquivo' : 'a pasta' }}.</small>
      </div>
      <button class="icon-button" type="button" (click)="closeShareModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form *ngIf="shareStep === 'form'" [formGroup]="shareForm" (ngSubmit)="generateShareLink()">
      <label class="toggle-row modern-checkbox">
        <input type="checkbox" [(ngModel)]="shareIsActive" [ngModelOptions]="{ standalone: true }" />
        <span>Link ativo (desmarque para tirar do ar)</span>
      </label>

      <label class="toggle-row modern-checkbox">
        <input type="checkbox" formControlName="password_enabled" [disabled]="!shareIsActive" />
        <span>Proteger com senha</span>
      </label>

      <label>Senha
        <div class="password-row modal-input-row">
          <input type="text" formControlName="password" placeholder="Defina uma senha segura" [disabled]="!shareIsActive || !shareForm.value.password_enabled" />
          <button class="btn ghost" type="button" (click)="generateStrongPassword()" [disabled]="!shareIsActive">Gerar senha forte</button>
        </div>
      </label>

      <label>Expira em
        <input type="date" formControlName="expires_at" [disabled]="!shareIsActive" />
      </label>

      <div class="existing-link-box" *ngIf="shareLinkId">
        <small>Dados atuais</small>
        <div class="current-share-grid">
          <div class="full-row">
            <span class="current-label">Link atual</span>
            <div class="current-value-row">
              <p class="is-link">{{ shareLink || '-' }}</p>
              <button class="btn ghost mini" type="button" (click)="copyShareLink()" [disabled]="!shareLink">Copiar</button>
            </div>
          </div>
          <div class="full-row">
            <span class="current-label">Senha atual</span>
            <div class="current-value-row">
              <p>{{ shareCurrentPasswordValue || '-' }}</p>
              <button class="btn ghost mini" type="button" (click)="copyCurrentSharePassword()">Copiar</button>
            </div>
          </div>
          <div>
            <span class="current-label">Expiração atual</span>
            <p>{{ shareCurrentExpiresAt ? (shareCurrentExpiresAt | date:'short') : 'Sem expiração' }}</p>
          </div>
          <div>
            <span class="current-label">Status</span>
            <p>{{ shareIsActive ? 'Ativo' : 'Inativo' }}</p>
          </div>
        </div>
      </div>

      <div class="modal-footer-actions">
        <button class="btn outline" type="button" (click)="closeShareModal()">Cancelar</button>
        <button class="btn primary" type="submit" [disabled]="!canSubmitShare()">
          {{ shareGenerating ? 'Salvando...' : (shareLinkId ? 'Salvar compartilhamento' : 'Gerar link') }}
        </button>
      </div>
    </form>
    <div class="share-result" *ngIf="shareStep === 'result'">
      <label>Link seguro
        <input type="text" [value]="shareLink" readonly />
      </label>
      <div class="share-actions">
        <button class="btn outline" type="button" (click)="copyShareLink()">Copiar link</button>
      </div>
      <label>Senha
        <input type="text" [value]="sharePassword" readonly />
      </label>
      <div class="share-actions">
        <button class="btn outline" type="button" (click)="copySharePassword()">Copiar senha</button>
        <button class="btn outline" type="button" (click)="copyShareAll()">Copiar tudo</button>
      </div>
      <div class="modal-footer-actions">
        <button class="btn ghost" type="button" (click)="backToShareForm()">Voltar</button>
        <button class="btn primary" type="button" (click)="closeShareModal()">Fechar</button>
      </div>
    </div>
  </div>
</div>

<div class="share-modal-backdrop" *ngIf="previewModalVisible">
  <div class="share-modal preview-modal">
    <header>
      <div>
        <h3>{{ previewTitle || 'Visualização do arquivo' }}</h3>
        <small class="preview-kind-chip">
          <mat-icon>{{ previewTypeIcon }}</mat-icon>
          {{ previewTypeLabel || 'Arquivo' }}
        </small>
      </div>
      <button class="icon-button" type="button" (click)="closePreviewModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="preview-body" [ngClass]="'kind-' + previewKind" *ngIf="previewUrl; else previewUnavailable">
      <iframe *ngIf="previewKind === 'pdf'" [src]="previewSafeUrl" title="Visualização PDF"></iframe>
      <img *ngIf="previewKind === 'image'" [src]="previewUrl" alt="Visualização imagem">
      <video *ngIf="previewKind === 'video'" [src]="previewUrl" controls></video>
      <audio *ngIf="previewKind === 'audio'" [src]="previewUrl" controls></audio>
      <div class="preview-fallback" *ngIf="previewKind === 'unsupported'">
        <mat-icon>insert_drive_file</mat-icon>
        <p>Pré-visualização não disponível para este tipo de arquivo.</p>
      </div>
    </div>

    <ng-template #previewUnavailable>
      <div class="preview-fallback">
        <mat-icon>error_outline</mat-icon>
        <p>Não foi possível carregar pré-visualização deste arquivo.</p>
      </div>
    </ng-template>

    <div class="share-actions preview-actions">
      <button class="btn outline" type="button" (click)="openPreviewInNewTab()">
        <mat-icon>open_in_new</mat-icon>
        Abrir em nova aba
      </button>
      <button class="btn primary" type="button" (click)="downloadPreviewFile()" [disabled]="!previewDownloadUrl">
        <mat-icon>download</mat-icon>
        Download
      </button>
    </div>
  </div>
</div>
